import React , { useState,useEffect }from 'react'
import { Layout} from 'antd';
import { Form} from 'antd';
import { useLocation } from 'react-router-dom'; 

const { Header, Content, Footer } = Layout;

const View =(props)=>{
    const [form] = Form.useForm();
    const [bChecked,setChecked] = useState(false);
    const location = useLocation(); 

    useEffect(() => {

        let params = new URLSearchParams(location.search);
        let url = params.get("url");

      let height = window.innerHeight;
      let width = window.innerWidth;
      document.getElementById("innerbox").style.width = width + 'px';
      document.getElementById("innerbox").style.height = height + 'px';
      document.getElementById("innerbox").src = url;
    }, [form]);

  return (
    <Layout className="layout" style={{display:"block"}}>
        <Content>
        <div style={{overflow:"hidden",scrollbarWidth:"none"}}>
        <iframe id='innerbox' style={{border:"none",scrollbarWidth:"none"}} src=''></iframe>
        </div>
        </Content>
    </Layout>
  )
}
export default View
